/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestChangePasswordRequest } from '../../models/request-change-password-request';
import { TwoFaExpiry } from '../../models/two-fa-expiry';

export interface RequestChangePassword$Params {
      body: RequestChangePasswordRequest
}

export function requestChangePassword(http: HttpClient, rootUrl: string, params: RequestChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFaExpiry>> {
  const rb = new RequestBuilder(rootUrl, requestChangePassword.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFaExpiry>;
    })
  );
}

requestChangePassword.PATH = '/users/request-change-password';
